var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionFolderImportOutlined({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.586V2h-2v10.586l-2.293-2.293-1.414 1.414L14 16.414l4.707-4.707-1.414-1.414L15 12.586Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.828V5l-1-1H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-3v2h3v10H4V6h5.172L11 7.828Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionFolderImportOutlined);
export default __webpack_public_path__ + "static/media/ic_action_folder_import_outlined.c2adf1b84a2b7a844ee22452c11bf8a8.svg";
export { ForwardRef as ReactComponent };